import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

// Tabela genérica pro tableContent do ChartCard (componentes/chart/CardChart.jsx) — serve
// qualquer gráfico construído a partir de pares [label, valor] (a imensa maioria dos gráficos de
// Solicitações), evitando escrever uma tabela dedicada por gráfico.
export default function TabelaEntriesGrafico({ entries, colunaLabel = "Item", colunaValor = "Valor", formatarValor = v => v }) {
    const linhas = entries.map(([label, valor]) => ({ label, valor }));
    return (
        <DataTable value={linhas} size="small" scrollable scrollHeight="260px"
            emptyMessage="Sem dados para exibir." className="text-xs">
            <Column field="label" header={colunaLabel} />
            <Column field="valor" header={colunaValor} sortable body={row => formatarValor(row.valor)} />
        </DataTable>
    );
}
